import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import { Game } from '@models/games/Game';
import { isMobile } from '@src/core/utils/userAgent/UAUtils';
import IGameDto from './dtos/IGameDto';

export default class GameMapper extends AbstractMapper<IGameDto, Game> {
    createTargetObject(gameDto: IGameDto): Game {
        const demoGameUrl = isMobile() ? gameDto.demoGameMobileUrl : gameDto.demoGameDesktopUrl;
        const game: Game = {
            demoGameUrl,
            name: gameDto.name,
            externalId: parseInt(gameDto.externalId, 10),
            isNew: gameDto.new,
            isJackpot: gameDto.jackpot,
            hasDemo: !!demoGameUrl,
            // all images are stored and exposed with resolution 90px
            // we need manually switch to 223px
            imageSrc: gameDto.imgsrc ? gameDto.imgsrc.replace('_90.', '_223.') : '',
            aspectRatio: gameDto.aspect,
            width: gameDto.width,
            height: gameDto.height,
            fullGameUrl: gameDto.fullGameDesktopUrl,
            fullMobileGameUrl: gameDto.fullGameMobileUrl,
            order: parseInt(gameDto.order, 10),
            test: gameDto.test || false,
            loggedOutDemo: gameDto.loggedOutDemo,
            isLive: false,
        };
        return game;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/game/GameMapper.ts